import { render, staticRenderFns } from "./kng-lib-selector.vue?vue&type=template&id=1453fbb8"
import script from "./kng-lib-selector.vue?vue&type=script&lang=js"
export * from "./kng-lib-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports